<template>
    <v-select
        v-model="model"
        :label="`Inline Fixture Version${required ? ' *' : ''}`"
        :items="ALL_INLINE_FIXTURE_VERSIONS"
        @update:modelValue="syncVModel"
        item-value="value"
        :item-title="showDescriptions ? 'longTitle' : 'shortTitle'"
        :error-messages="errorMessages"
        @blur="$emit('blur')"
    >
        <!-- <template #item="{ item, props }">
            <v-list-item v-bind="props" :title="titleForItem(item)">
                <template v-slot:prepend>{{ item.raw.flagEmoji }}&nbsp;&nbsp;</template>
            </v-list-item>
        </template> -->
    </v-select>
</template>

<script lang="ts" setup>
import type { InlineFixtureVersionsV1 } from '@geckoal/gecko-api-client'
import { ref, watch, type PropType } from 'vue'
import { ALL_INLINE_FIXTURE_VERSIONS } from '../../lib/inlineFixtureVersions'

const props = defineProps({
    modelValue: {
        type: String as PropType<InlineFixtureVersionsV1>
    },
    required: {
        type: Boolean
    },
    showDescriptions: {
        type: Boolean
    },
    errorMessages: {
        type: Array as PropType<string[]>
    }
})

const model = ref<InlineFixtureVersionsV1 | undefined>()

watch(
    () => props.modelValue,
    (value) => {
        model.value = value
    },
    { immediate: true }
)

const emit = defineEmits(['update:modelValue', 'blur'])

const syncVModel = () => {
    emit('update:modelValue', model.value)
}
</script>
